import { retrieveLaunchParams } from '@telegram-apps/sdk-react';
import { normalizeLocale, type Locale } from '@veylme/shared';

/**
 * Определить язык интерфейса Mini App из «сырого» кода языка Telegram/браузера
 * и нормализовать его к одному из поддерживаемых (SUPPORTED_LOCALES, work-026).
 *
 * Источники (в порядке приоритета):
 *  1. `tgWebAppData.user.language_code` из launch params SDK (IETF-тег).
 *     Обёрнуто в try/catch — может бросить, если SDK не инициализирован.
 *  2. `navigator.language` — запасной (браузерный язык).
 *  3. Дефолт — 'en'.
 *
 * Это лишь ПЕРВАЯ догадка при самом первом входе. Явный выбор пользователя
 * (User.locale на сервере + localStorage) перекрывает её — см. App.tsx.
 *
 * Сам маппинг кодов живёт в shared `normalizeLocale` — единый источник правды
 * для клиента и сервера (бот/API).
 */
export function detectLocale(): Locale {
  try {
    const lp = retrieveLaunchParams();
    const m = normalizeLocale(lp.tgWebAppData?.user?.language_code);
    if (m) return m;
  } catch {
    // SDK не инициализирован / вне Telegram — переходим к fallback.
  }
  if (typeof navigator !== 'undefined') {
    const m = normalizeLocale(navigator.language);
    if (m) return m;
  }
  return 'en';
}
